// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Sign/style.css
 ** module id = 1598
 ** module chunks = 0
 **/